import { Button, Stack } from "@mui/material";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";
import { MAX_REVIEWS } from "../../../../lib/constants";
import { MaterialCard } from "../../../explore/material/cards/MaterialCard";
import { useState } from "react";

export const ListingSimilarListingsMobileSlider = () => {
  const listingRedux = useSelector((state: RootState) => state.trainingPlan);
  const [maxIndexList, setMaxIndexList] = useState(MAX_REVIEWS);
  const theme = useSelector((state: RootState) => state.theme);
  return (
    <Stack className="space-y-[8px]">
      <Stack className="w-full grid-cols-1 sm:grid-cols-2 grid gap-2">
        {listingRedux.similarListings.rows.map((listing, i) => {
          if (i > maxIndexList) {
            return;
          }
          if (i <= maxIndexList && listing.id != listingRedux.listingData.id) {
            return (
              <Stack key={i}>
                <MaterialCard data={listing} />
              </Stack>
            );
          }
        })}
      </Stack>

      {listingRedux.similarListings.rows.length - 1 > maxIndexList && (
        <Button
          sx={{
            textTransform: "none",
            color: theme.componentColors.primary.primary,
          }}
          onClick={() => setMaxIndexList((prev) => prev + 3)}
        >
          Load More
        </Button>
      )}
    </Stack>
  );
};
